import { DatafeedConfiguration } from 'trading-view';

const API_ENDPOINT = 'https://benchmarks.pyth.network/v1/shims/tradingview';

export const fetcher = async () => {
  return {
    supported_resolutions: [
      '1',
      '2',
      '5',
      '15',
      '30',
      '60',
      '120',
      '240',
      '360',
      '720',
      'D',
      '1D',
      'W',
      '1W',
      'M',
      '1M',
    ],
    supports_group_request: false,
    supports_marks: false,
    supports_search: true,
    supports_timescale_marks: false,
  };
  const _url = `${API_ENDPOINT}/config`;
  const res = await fetch(_url);
  const response = (await res.json()) as DatafeedConfiguration;

  return response;
};
